import axios from "axios";
import api from "./api";
import utils from "./utils";
import tokenService from "../service/tokenService";

export default {

    //get请求
    get: function (uri, data) {
        return this.request('get', uri, data);
    },
    //post请求
    post: function (uri, data) {
        return this.request('post', uri, data);
    },
    //总的请求方法
    request: function (method, uri, params) {
        return new Promise((resolve, reject) => {
            method = method.toLocaleUpperCase();
            let token = tokenService.getToken();
            axios({
                baseURL: api.WEB_URL+'/api',
                method: method,
                url: uri,
                //timeout: 1000,
                responseType: 'json',
                headers: {
                    "Authorization": 'Bearer ' + token,//验证码
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                data: (method === 'POST' && !utils.isEmpty(params)) ? params : null,
                params: (method === 'GET' && !utils.isEmpty(params)) ? params : null,
            }).then((res) => {
                if (res.status === 200) {
                    let ret = res.data;
                    if (!utils.isObject(ret)) {
                        window.$vue.$message.error('数据格式错误！');
                        reject({data: false, code: 5004, msg: '数据格式错误'});
                        return;
                    }
                    if(ret.code !== 0){
                        window.$vue.$message({
                            'title': '错误',
                            'message': ret.message,
                            'type': 'error',
                            'dangerouslyUseHTMLString': true,
                        });
                        return;
                    }

                    //过期
                    // location.href = api.WEB_URL;
                    // return;

                    //请求成功
                    resolve(ret.data);
                } else {
                    window.$vue.$message({
                        'title': '错误',
                        'message': res.statusText,
                        'type': 'error',
                        'dangerouslyUseHTMLString': true,
                    });
                    reject(res.data);
                }
            }).catch(function (error) {
                // let msg = '';
                // let code = '';
                if (error.response) {
                   var response =  error.response
                    window.$vue.$message({
                        'title': '错误',
                        'message': response.statusText+':'+response.status,
                        'type': 'error',
                        'dangerouslyUseHTMLString': true,
                    });
                   return

                    //权限拒绝
                    // if (error.response.status === 403 || error.response.status === 401) {
                    //     // self.redirectToLogin();
                    //     return;
                    // } else if (error.response.status === 502) {
                    //     code = 5003;
                    //     msg = '无法连接到目标服务器,请检查网络是否联通';
                    // }
                } else if (error.request) {
                    // if (error.message === 'Network Error') {
                    //     code = 5001;
                    //     msg = '网络异常，请检查网络是否联通';
                    // } else if (error.request.timeout === 1 || error.request.status === 504) {
                    //     code = 5002;
                    //     msg = '请求超时,请稍后再试(请检查网络是否联通)!';
                    // }
                }
                //
                // if (error.message === "Request failed with status code 401") {
                //     self.redirectToLogin();
                //     return;
                // }
                //
                // if (!msg) {
                //     code = 5003;
                //     msg = error.message;
                // }
                //
                // window.$vue.$message({
                //     message: msg,
                //     type: 'error',
                //     dangerouslyUseHTMLString: true,
                //     customClass: 'zZindex'
                // });
                reject({data: false, code: 'code', msg: 'msg'});
            });
        });
    },

    //跳转登陆
    redirectToLogin: function () {
        location.href = api.WEB_URL+'/signin';
    },
}
